import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import { Container } from 'react-bootstrap';
import cx from 'classnames';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import { injectIntl } from 'react-intl';
import { FormattedMessage } from 'react-intl';
import messages from '../../../locale/messages';
import { isRTL } from '../../../helpers/formatLocale';
import { getDynamicTitleByLocale } from '../../../helpers/getDynamicTitle';
import {
  siteUrl,
  homePageCategoryBannerUploadDir
} from '../../../config';
import { SwiperNextIcon, SwiperPrevIcon } from '../../Common/Assets/SVGIcon/CommonSvgIcon';
import n from 'swiper/swiper-bundle.css';
import c from '../../../styles/customSwiper.css'
import s from './HomePageCategorySection.css';

const ArrowButton = ({ className, children }) => (
  <button className={cx('topCategorySwiperNavigationBtn', className)}>
    {children}
  </button>
);

const HomePageCategorySection = ({ data = [], currentLocale, intl: { locale } }) => {
  const rtl = isRTL(locale);

  const params = {
    slidesPerView: 1,
    spaceBetween: 10,
    modules: [Navigation],
    navigation: {
      nextEl: `.topCategorySwiperNavigationNextBtn`,
      prevEl: `.topCategorySwiperNavigationPrevBtn`,
    },
    breakpoints: {
      // when window width is >= 320px
      320: {
        slidesPerView: 1,
      },
      // when window width is >= 576px
      576: {
        slidesPerView: 2,
      },
      // when window width is >= 768px
      768: {
        slidesPerView: 3,
        spaceBetween: 15,
      },
      // when window width is >= 1024px
      1024: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      // when window width is >= 1200px
      1200: {
        slidesPerView: 4,
        spaceBetween: 42,
      }
    }
  };
  return (
    <div className={cx(s.topCategoryContainer)}>
      <Container>
        <h2 className={cx(s.topCategorySliderHeading)}><FormattedMessage {...messages.topFeaturesText} /></h2>
        <div className={s.topCategorySliderWrapper}>
          <Swiper
            {...params}
            key={rtl} // force remount on language change
            dir={rtl ? 'rtl' : 'ltr'}
          >
            {data.length > 0 && data
              .filter(item => item?.isActive).map((item, index) => {
                const dynamicSettings = getDynamicTitleByLocale({
                  dynamicHomePageSettings: item?.dynamicHomePageCategorySettings,
                  locale: currentLocale
                });

                const banner = item?.banner;
                const title = dynamicSettings[0]?.title || item?.title;
                const description = dynamicSettings[0]?.description || item?.description;

                return (

                  <SwiperSlide key={index}>
                    {item?.isActive && (
                      <div className={s.topCategorySliderListItemBox}>
                        <div className={s.topCategorySliderListItemImg}>
                          <img
                            src={`${siteUrl}${homePageCategoryBannerUploadDir}medium_${banner}`}
                            alt={title}
                          />
                        </div>
                        <div className={s.topCategorySliderListItemInfo}>
                          <div className={s.topCategorySliderListItemTitle}>{title}</div>
                          <div className={s.topCategorySliderListItemDesc}>{description}</div>
                        </div>
                      </div>
                    )}
                  </SwiperSlide>
                );
              })}
          </Swiper>
          <ArrowButton className={cx('topCategorySwiperNavigationPrevBtn')}>
            <SwiperPrevIcon />
          </ArrowButton>
          <ArrowButton className={cx('topCategorySwiperNavigationNextBtn')}>
            <SwiperNextIcon />
          </ArrowButton>
        </div>
      </Container>
    </div>
  );
};

export default injectIntl(withStyles(n, s, c)(HomePageCategorySection))
